import { useIntl } from 'react-intl';

import { getTranslatedResult } from 'services/user/resultTranslationHelper';

import { Tooltip } from 'components';

import { AssessmentCounterProps } from './types';

import * as S from './styles';

const AssessmentCounter: React.FC<AssessmentCounterProps> = ({
  value,
  result,
}) => {
  const intl = useIntl();

  // Grade colour code feature - Not implemented atm, will be enabled in the future
  /* const counterGrade = () => {
    switch (result) {
      case 'lbl-none-minimal':
      case 'lbl-mild':
      case 'lbl-moderate':
        return 'low';
      case 'lbl-moderately-severe':
        return 'medium';
      case 'lbl-severe':
        return 'high';
      default:
        return undefined;
    }
  }; */

  return (
    <S.AssessmentCounter data-testid="assessmentCounter">
      <Tooltip
        available={!!result}
        position="top-center"
        description={result ? getTranslatedResult(result, intl) : ''}
      >
        <S.AssessmentCounterNumber>
          {value !== undefined && value >= 0 ? value : '-'}
        </S.AssessmentCounterNumber>
      </Tooltip>
    </S.AssessmentCounter>
  );
};

export default AssessmentCounter;
